import React from 'react';
import styled from 'styled-components';

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';
const whatsappIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/whatsapp-white.svg';
import Button from '../../../../components/Button';
import ContainerModal from '../../../../components/ContainerModal';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { useSpecialistContext } from '../../../../contexts/SpecialistContext';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { useModuleContext } from '../../../../contexts/ModuleContext';
import { FirebaseEvents } from '../../../../utils/enums/firebase-events';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;

  & .title {
    font-weight: 500;
    font-size: 24px;
    color: var(--color-gray-500);
    line-height: 32px;
    text-align: center;
    width: 308px;
  }

  & .subtitle {
    font-weight: 500;
    font-size: 16px;
    color: var(--color-gray-400);
    line-height: 24px;
    text-align: center;
  }

  & .tel {
    font-weight: 600;
    font-size: 16px;
    color: var(--blue-einstein);
    line-height: 24px;
  }
`;

const ButtonClose = styled(Button)``;

type ModalServiceUnavailableProps = {
  visible: boolean;
  onClickClose: () => void;
  onClickWhatsapp: () => void;
};
export const ModalServiceUnavailable: React.FC<ModalServiceUnavailableProps> = ({
  visible,
  onClickClose,
  onClickWhatsapp
}) => {
  const { logEvent } = useAnalytics();
  const { selectedItem, scheduleSpecialistSelected } = useScheduleContext();
  const { selectedService } = useServiceContext();
  const { selectedSpecialist } = useSpecialistContext();
  const { selectedItemToSchedule } = useModuleContext();

  return (
    <ContainerModal
      visible={visible}
      onClose={onClickClose}
      withoutCloseButton
      childrenFooter={
        <>
          <Button
            disabled={!visible}
            type="button"
            title="Agendar pelo whatsapp"
            onClick={onClickWhatsapp}
            iconLeft={<img src={whatsappIcon} alt="whatsapp-icon" />}
          />
          <ButtonClose disabled={!visible} type="button" title="Fechar" onClick={onClickClose} />
        </>
      }
    >
      <Container>
        <img src={warningIcon} alt="warning" />
        <h3 className="title">Ainda não é possível agendar por aqui</h3>
        <p className="subtitle">
          Por enquanto, o agendamento do Einstein até você é apenas por WhatsApp ou pela central de atendimento:{' '}
          <a
            className="tel"
            href="tel:+551121511233"
            onClick={() => {
              logEvent({
                eventName: FirebaseEvents.schedule_redirect_call_center,
                eventParams: {
                  service_id: selectedService.id,
                  service_name: selectedService.name,

                  ...(selectedItemToSchedule === 'SPECIALIST'
                    ? {
                        product_name: selectedSpecialist?.name,
                        product_id: selectedSpecialist?.id,
                        unit_id: scheduleSpecialistSelected?.unit?.catalogId,
                        unit_name: scheduleSpecialistSelected?.unit?.name,
                        attendanceType: scheduleSpecialistSelected?.attendanceType
                      }
                    : {}),
                  ...(selectedItemToSchedule !== 'SPECIALIST'
                    ? {
                        product_name: selectedItem?.productName,
                        product_id: selectedItem?.productId,
                        unit_id: selectedItem?.unit?.catalogUnitId,
                        unit_name: selectedItem?.unit?.name,
                        attendanceType: selectedItem?.careType
                      }
                    : {}),
                  phone: '2151-1233',
                  reason: 'Ainda não é possível agendar por aqui'
                }
              });
            }}
          >
            (11) 2151-1233
          </a>
        </p>
      </Container>
    </ContainerModal>
  );
};
